import styled from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS } from '../../styles/variables';
import { getBackgroundColor } from '../../../alpha-helper';

export const ResultModalWrapper = styled.section`
  background-color: ${getBackgroundColor()};
  z-index: 101;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 60px 16px 16px 16px;
  height: fit-content;

  @media ${device.tablet} {
    width: 768px;
    padding: 32px 48px 48px 48px;
    top: 50%;
    right: auto;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  @media ${device.laptop} {
    width: 1024px;
    padding: 48px 60px 60px 60px;
  }
`;
export const InfoContaner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-top: 8px;
  padding-bottom: 16px;
  @media ${device.tablet} {
    gap: 48px;
    padding-top: 28px;
    padding-bottom: 0;
  }
  @media ${device.laptop} {
    padding-top: 0;
    gap: 60px;
  }
`;
export const Result = styled.div`
  /* width: 50%; */
  @media ${device.tablet} {
    max-width: 278px;
  }
  @media ${device.laptop} {
    max-width: none;
  }
`;
export const Status = styled.div`
  background-color: rgba(0, 0, 0, 0.05);
  padding: 4px 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  font-family: Audi Type;
  font-style: normal;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
  width: fit-content;

  @media ${device.tablet} {
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.002px;
  }
  @media ${device.laptop} {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.003px;
  }
`;

export const IconWrapper = styled.div`
  @media ${device.tablet} {
    width: 24px;
    height: 24px;
  }
  @media ${device.laptop} {
    width: 24px;
    height: 24px;
  }
`;
export const HeaderInfo = styled.h2<{ isGeneralForm?: boolean }>`
  margin-top: 16px;
  font-family: Audi Type Extended;
  font-style: normal;
  font-weight: 700;

  text-align: ${({ isGeneralForm }) => (isGeneralForm ? 'center' : 'left')};
  @media ${device.tablet} {
    font-size: 24px;
    line-height: 36px; /* 150% */
    letter-spacing: 0.002px;
  }
  @media ${device.laptop} {
    font-size: 32px;
    line-height: 48px;
    letter-spacing: 0.003px;
  }
`;
export const TextInfo = styled.p`
  margin-top: 24px;
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
`;
export const CTABlock = styled.div<{ isGeneralForm?: boolean }>`
  margin-top: 40px;
  display: flex;
  gap: 12px;
  flex-direction: ${({ isGeneralForm }) => (isGeneralForm ? 'row-reverse' : 'column')};
`;

export const CTA = styled.button<{ isPrimary?: boolean; isGeneralForm?: boolean }>`
  padding: 0;
  border: none;
  width: ${({ isGeneralForm }) => (isGeneralForm ? 'fit-content' : '100%')};
  padding: 16px 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ isPrimary }) => (isPrimary ? COLORS.black : 'initial')};
  border: 1px solid ${COLORS.black};
  color: ${({ isPrimary }) => (isPrimary ? COLORS.white : COLORS.black)};
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.003px;
`;

export const CTAredirect = styled.a<{ isPrimary?: boolean; isGeneralForm?: boolean }>`
  padding: 0;
  border: none;
  width: ${({ isGeneralForm }) => (isGeneralForm ? 'fit-content' : '100%')};
  padding: 16px 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ isPrimary }) => (isPrimary ? COLORS.black : 'initial')};
  border: 1px solid ${COLORS.black};
  color: ${({ isPrimary }) => (isPrimary ? COLORS.white : COLORS.black)};
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.003px;
`;

export const Vehicle = styled.div``;
export const ImageWrapper = styled.div`
  background-color: ${COLORS.grey5};
  position: relative;
  @media ${device.tablet} {
    width: 346px;
    height: 258px;
  }
  @media ${device.laptop} {
    height: 358px;
    width: 480px;
  }
`;
export const VehicleImage = styled.img`
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;
export const VehicleInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  margin-top: 24px;
`;
export const ModelName = styled.h2`
  font-family: Audi Type Extended;

  font-style: normal;
  font-weight: 400;

  text-align: right;
  @media ${device.tablet} {
    font-size: 20px;
    line-height: 32px; /* 160% */
    letter-spacing: 0.002px;
  }
  @media ${device.laptop} {
    font-size: 24px;
    line-height: 36px; /* 150% */
    letter-spacing: 0.002px;
  }
`;
export const Trimline = styled.div`
  margin-top: 8px;
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.003px;
  color: ${COLORS.grey60};
`;

export const ContactInfo = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 24px;
  gap: 12px;
  align-items: center;
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  line-height: 24px; /* 150% */
  letter-spacing: 0.003px;
`;

export const PhoneNumber = styled.a`
  color: ${COLORS.black};
`;
